import { testFbId } from './index'

//
//
//
// Consulta ID DO CONVITE de um grupo
//
//
//

const getGroupInviteId = async groupID => {
  const request = await testFbId.ref(`grupos/${groupID}/idconvite`).once('value')
  return request && request.val() ? String(request.val()) : ''
}

//
//
//
// Consulta GRUPO através do ID
//
//
//

const getGroup = async groupID => {
  const request = await testFbId.ref(`grupos/${groupID}`).once('value')
  return request && request.val() ? request.val() : false
}

//
//
//
// Entrar no grupo
//
//
//

const apiJoinGroup = async (userID, groupID) => {
  const updates = {}
  updates['grupos/' + groupID + '/users/' + userID] = { admin: false, enablePush: true }
  updates['users/' + userID + '/grupos/' + groupID] = { admin: false, enablePush: true }

  //
  // Executa operações no banco de dados
  //

  return new Promise((resolve, reject) => {
    try
    {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível entrar no grupo. Por favor, tente novamente ou fale com o nosso suporte.',
          })
        } else {
          resolve({
            code: 1,
            message: '',
          })
        }
      })
    }
    catch (e)
    {
      resolve({
        code: 0,
        message: 'Não foi possível entrar no grupo. Por favor, tente novamente ou fale com o nosso suporte.',
      })
    }
  })
}

//
//
//
// SAÍDA
//
//
//

export {
  getGroupInviteId,
  getGroup,
  apiJoinGroup,
}
